/** @type {import('tailwindcss').Config} */

module.exports = {
  content: [
    "./*.{php,html}"
  ],
  blocklist: [
    'build',
    'node_modules'
  ],
  darkMode: "class",
  theme: {
    extend: {
      colors: {
        "on-primary": "#ffefeb",
        "background": "#fcf5ed",
        "surface-container-high": "#e9e1d8",
        "on-error": "#ffefee",
        "on-tertiary": "#f5f0ff",
        "on-surface-variant": "#5f5b55",
        "on-secondary": "#c2fff0",
        "surface-container-lowest": "#ffffff",
        "error": "#b31b25",
        "tertiary": "#5749c0",
        "surface": "#fcf5ed",
        "on-primary-fixed": "#000000",
        "primary-dim": "#922c00",
        "on-primary-container": "#451000",
        "error-dim": "#9f0519",
        "secondary-container": "#97f3e0",
        "outline-variant": "#b2aca5",
        "outline": "#7b7670",
        "primary": "#a73300",
        "on-secondary-container": "#005d50",
        "secondary-fixed-dim": "#89e5d2",
        "on-tertiary-fixed": "#13005b",
        "on-secondary-fixed": "#00483e",
        "surface-tint": "#a73300",
        "tertiary-container": "#afa6ff",
        "on-error-container": "#570008",
        "inverse-surface": "#100e0a",
        "tertiary-fixed-dim": "#a096ff",
        "tertiary-dim": "#4a3bb4",
        "on-surface": "#312e29",
        "primary-fixed-dim": "#f56633",
        "on-secondary-fixed-variant": "#00685a",
        "secondary": "#00685a",
        "on-primary-fixed-variant": "#551600",
        "on-tertiary-fixed-variant": "#331f9d",
        "surface-container-low": "#f7f0e7",
        "surface-variant": "#e3dcd2",
        "on-background": "#312e29",
        "inverse-primary": "#fc6b37",
        "tertiary-fixed": "#afa6ff",
        "secondary-dim": "#005a4e",
        "surface-dim": "#dbd3c9",
        "secondary-fixed": "#97f3e0",
        "primary-container": "#ff794a",
        "surface-container": "#eee7de",
        "surface-bright": "#fcf5ed",
        "error-container": "#fb5151",
        "on-tertiary-container": "#2a1095",
        "primary-fixed": "#ff794a",
        "surface-container-highest": "#e3dcd2",
        "inverse-on-surface": "#a19c95",
        "tertiary-lighten": "#7c73c2"
      },
      borderRadius: {
        DEFAULT: "0.25rem",
        lg: "0.5rem",
        xl: "0.75rem",
        full: "9999px",
      },
      backgroundImage: {
        'hero-texture': "url('../assets/images/bg_hero_10.jpg')",
        'class-texture': "url('../assets/images/Set3_2_pink.jpg')",
        'hero-about-picture': "url('../assets/images/about.jpg')",
      }
    },
    fontFamily: {
      headline: ["Fredoka", "Times New Roman"],
      body: ["Poppins", "Arial"],
      label: ["Poppins", "Arial"],
    },
  },
};
